import { render, staticRenderFns } from "./GoodDataTable.vue?vue&type=template&id=39851af9&scoped=true&"
import script from "./GoodDataTable.vue?vue&type=script&lang=js&"
export * from "./GoodDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GoodDataTable.vue?vue&type=style&index=0&id=39851af9&prod&lang=scss&"
import style1 from "./GoodDataTable.vue?vue&type=style&index=1&id=39851af9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39851af9",
  null
  
)

export default component.exports